import React from "react";
import "./App.css";
import LoanCalculator from "./components/LoanCalculator";

function App() {
  return (
    <div className="App">
      <LoanCalculator />
    </div>
  );
}

export default App;
